module.exports = __webpack_public_path__ + "static/media/step4_gif.66fd7f42.gif";